import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LockScreen } from "./LockScreen";

export const Loader = () => (
  <div className="min-h-[60vh] grid place-items-center" data-testid="page-loader">
    <div className="w-10 h-10 rounded-full border-2 border-[#E5C158]/20 border-t-[#E5C158] animate-spin" />
  </div>
);

export const ProtectedRoute = ({ children, requirePaid = true }) => {
  const { user } = useAuth();
  if (user === null) return <Loader />;
  if (!user) return <Navigate to="/auth?mode=login" replace />;
  if (requirePaid && !user.paid) return <Navigate to="/paywall" replace />;
  if (requirePaid && user.pin_enabled && !user.pin_unlocked) return <LockScreen />;
  return children;
};
